/* eslint-disable spire/export-styles */
import { AuerState } from "@auer-steel/Store/AuerState";
import updateInvoicePayments from "@auer-steel/Store/Pages/PayInvoice/Handlers/UpdateInvoicePayments";
import { ACHWalletSelection } from "@auer-steel/Widgets/Common/PayfabricWallet/ACHWalletSelection";
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Select from "@insite/mobius/Select";
import TextField from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import React, { ChangeEvent, SyntheticEvent, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

export interface InvoiceAchEntryStyles {
    achContainer?: GridContainerProps;
    fullWidthGridItem?: GridItemProps;
}

const styles: InvoiceAchEntryStyles = {
    achContainer: {
        gap: 10,
    },
    fullWidthGridItem: {
        width: 12,
    },
};

interface OwnProps {
    error: string | boolean,
}


const mapStateToProps = (state: AuerState) => {
    return { invoicePaymentCollection: state.payInvoice.invoicePaymentCollection };
};

const mapDispatchToProps = {
    updateInvoicePayments,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const InvoiceAchEntry: React.FunctionComponent<Props> = props => {
    const [achAccountId, setAchAccountId] = useState("");
    const [paymentMethodError, setPaymentMethodError] = useState("");

    const isNonEmptyString = (value: string | undefined) => value !== undefined && value.trim() !== "";

    const handleAchFieldChange = (fieldName: string, value: string | number, error?: string, errorField?: string) => {
        const errorFieldName = errorField ?? `${fieldName}Error`;
        props.updateInvoicePayments({
            ...props.invoicePaymentCollection,
            achAccountId: value as string,
        });
    };

    // B2BES [AST-426] - ADD Customization - Ensure if ACH is chosen that a valid ACH account is selected. Part of AST-359 EVO Payments
    const validateAchWalletId = (achWalletId: string) => {
        const achWalletIdValid = isNonEmptyString(achWalletId);
        setPaymentMethodError(!achWalletIdValid ? translate("Select ACH Account is required.") : "");
        return achWalletIdValid;
    };

    const handleACHWalletLoad = (defaultOption: string) => {
        handleAchFieldChange("achAccountId", defaultOption);
    }

    const handleACHWalletChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        validateAchWalletId(event.target.value);
        handleAchFieldChange("achAccountId", event.target.value);
    };

    return (
        <GridContainer {...styles.achContainer}>
            <GridItem {...styles.fullWidthGridItem}>
                <ACHWalletSelection
                    onLoad={handleACHWalletLoad}
                    walletChangeHandler={handleACHWalletChange}
                    error={props.error} />
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceAchEntry);
